import React, {PropTypes} from 'react';
import { Link } from 'react-router-dom'
import { Image } from 'react-bootstrap';

export default class BackNavLink extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    const {to} = this.props

    return (<div className="back-nav-link">

        <Image
          src="https://s3.amazonaws.com/everlance-dashboard/assets/images/Back+Filled-100-337ab7.png"
        />
        <Link to={to}>Back</Link>


      </div>);
  }
}

BackNavLink.propTypes = {
};



// WEBPACK FOOTER //
// ./src/core/components/BackNavLink.js